import { SSR, BREAKPOINT_DESKTOP_FROM } from './constants';
import {
  getLayoutContextValue as getDeprecatedLayoutContextValue,
  LayoutContextValue as DeprecatedValue,
} from './deprecated/getLayoutContextValue';
import { warning as deprecationWarning } from './deprecated/warning';
import { checkIfHasHover } from './helpers/hoverMedia';

deprecationWarning();

type Viewport = {
  viewportWidth: number;
  viewportHeight: number;
};

type WindowViewport = Viewport & {
  innerWidth?: number;
};

const getWindowViewport = (): WindowViewport => {
  if (typeof window === 'undefined') {
    return {
      viewportWidth: SSR.VIEWPORT_WIDTH,
      viewportHeight: SSR.VIEWPORT_HEIGHT,

      innerWidth: SSR.VIEWPORT_WIDTH,
    };
  }

  return {
    viewportWidth: window.document.documentElement.clientWidth,
    viewportHeight: window.document.documentElement.clientHeight,

    innerWidth: window.innerWidth,
  };
};

const checkIfTouchDevice = (): boolean => {
  if (typeof window === 'undefined') {
    return SSR.IS_TOUCH_DEVICE;
  }

  const hasHover = checkIfHasHover();

  return !hasHover;
};

export type LayoutContextValue = {
  viewportWidth: number;
  viewportHeight: number;

  isDesktop: boolean;
  isMobile: boolean;

  isTouchDevice: boolean;
} & DeprecatedValue;

export const getLayoutContextValue = (viewport?: Viewport): LayoutContextValue => {
  const { viewportWidth, viewportHeight, innerWidth }: WindowViewport =
    viewport || getWindowViewport();

  const widthToCheck = innerWidth || viewportWidth;

  const isDesktop = widthToCheck >= BREAKPOINT_DESKTOP_FROM;
  const isMobile = !isDesktop;

  /** @todo FC-739 Подумать над тем, чтобы сделать флаг hasHover вместо isTouchDevice */
  const isTouchDevice = checkIfTouchDevice();

  return {
    viewportWidth,
    viewportHeight,

    isDesktop,
    isMobile,

    isTouchDevice,

    ...getDeprecatedLayoutContextValue(widthToCheck),
  };
};
